import { FC, memo } from 'react';
import { Container, Grid, Image } from 'semantic-ui-react';
import { css } from '@emotion/react/macro';
import { useHistory } from 'react-router-dom';
import SecondExpansion from '../../../assets/index/figure.png';
import SecondVisual from '../../../assets/index/HTMLboxlogoForgelogo.svg';
import ServiceText from '../../Molecules/ServiceText';
import DefaultButton from '../../Atoms/button/DefaultButton';
import { MainVisualText1 } from '../../../text/MainVisualText';
import { URL } from '../../../util';
import EntranceTitle from '../../Atoms/entrance/EntranceTitle';

const MainExpansion: FC = memo(() => {
  const history = useHistory();

  return (
    <Container css={containreMargin} style={{ width: '1024px' }}>
      <Grid textAlign="center">
        <EntranceTitle title="GrantDriveとは" />
      </Grid>
      <Grid>
        <Grid.Row css={columnStyle}>
          <Grid.Column width={6}>
            <Image src={SecondVisual} css={widthStyle} />
          </Grid.Column>
          <Grid.Column width={10}>
            <div css={secondTextMargin}>
              オープンリンクの
              <span css={blueColor}>パスワードを必須化して</span>
              <br />
              <span css={blueColor}>Box共有リンクのスマートな管理を</span>
              <br />
              実現するサービスです。
              <div css={newFeatureStyle}>
                <div css={newBadge}>NEW</div>
                <span css={blueColor}>有効期限の必須化</span>
                <br />
                共有リンク作成時に、指定した日数の有効期限を自動的に設定します。期限切れのリンクからの情報漏えいを防ぎます。
              </div>
              <div css={newFeatureStyle}>
                <div css={newBadge}>NEW</div>
                <span css={blueColor}>ダウンロード不可の必須化</span>
                <br />
                共有リンクの権限を強制的に「プレビューのみ」に変更することが可能です。ファイルの持ち出しや二次流出を防止します。
              </div>
            </div>
            <ServiceText text={MainVisualText1} mainVisual />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row css={imageGroup}>
          <Image src={SecondExpansion} css={secondImage} />
        </Grid.Row>
      </Grid>
      <Grid textAlign="center">
        <DefaultButton
          text="サービス概要"
          marginTp="80px"
          marginBt="100px"
          width="110%"
          size="huge"
          onClinckFunc={e => {
            e.preventDefault();
            history.push(URL.service);
          }}
        />
      </Grid>
    </Container>
  );
});

const secondImage = css`
  padding: 50px;
`;

const columnStyle = css`
  margin-bottom: 40px;
`;

const containreMargin = css`
  width: 1400px;
`;

const imageGroup = css`
  background-color: #fff;
`;

const secondTextMargin = css`
  font-size: 28px;
  line-height: 1.5em;
  margin-left: 20px;
  margin-bottom: 40px;
`;

const blueColor = css`
  color: #224ea8;
`;

const newFeatureStyle = css`
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.6em;
`;

const newBadge = css`
  display: inline-block;
  background-color: #e8573a;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 3px;
  margin-right: 8px;
  vertical-align: middle;
`;

const widthStyle = css`
  width: 100%;
`;

export default MainExpansion;
